import PropTypes from "prop-types"
import "./style.scss"

function Error({ text }) {
  return <div className="components_material-error">
    <div className="error-description">{text}</div>
  </div>
}

Error.propTypes = {
  text: PropTypes.string.isRequired,
}

export default Error
